import CreditLine from './CreditLine';

export default CreditLine;
